/* eslint-disable max-len */
import PropTypes from 'prop-types'
import { CrashTypes } from '../../models/crash-event/crash-types-enum'
import { RoadTypes } from '../../models/common/road-types-enum'
import { idPropType } from '../common/id-prop-type'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { positionPropType } from '../common/position-prop-type'

/**
 * @typedef {Object} CrashEvent
 *
 * @property {Id}                   objectId                                - The id of the object.
 * @property {Id}                   crashEventId                            - The id of the crash.
 * @property {number}               [accelerationDirection]                 - The acceleration direction in degrees.
 * @property {number}               [accelerationMagnitude]                 - The acceleration magnitude in mg.
 * @property {string}               [city]                                  - The city where the crash event occurred
 * @property {string}               [country]                               - The country where the crash event occurred
 * @property {string}               [crashType]                             - The crash type of the crash event
 * @property {ISO8601}              [eventTime]                             - The date of the crash event (ISO8601).
 * @property {bool}                 [inCity]                                - Crash event had occurred in city?
 * @property {number}               [odometer]                              - The odometer in hm in the moment of the crash event.
 * @property {Position}             [position]                              - The geo position of the starting accident (decimal degree).
 * @property {number}               [roadSpeedLimit]                        - The speed limit in the road where the crash event occurred
 * @property {roadType}             [roadType]                              - The road type where the crash event occurred
 * @property {number}               [speed]                                 - Speed at the moment the crash event occurred
 * @property {string}               [street]                                - The street where the crash event occurred
 * @property {string}               [zip]                                   - ZIP code where the crash event occurred
 */
export const crashEventPropType = PropTypes.shape({
    accelerationDirection: PropTypes.number,
    accelerationMagnitude: PropTypes.number,
    city: PropTypes.string,
    country: PropTypes.string,
    crashEventId: idPropType.isRequired,
    crashType: PropTypes.oneOf([CrashTypes.DRIVING, CrashTypes.PARKED]),
    eventTime: iso8601PropType.iso8601,
    inCity: PropTypes.bool,
    objectId: idPropType.isRequired,
    odometer: PropTypes.number,
    position: positionPropType,
    roadSpeedLimit: PropTypes.number,
    roadType: PropTypes.oneOf(Object.values(RoadTypes)),
    speed: PropTypes.number,
    street: PropTypes.string,
    zip: PropTypes.string
})
